import BenchlingConfig from 'BenchlingConfig';
import {
  ProcedureRunDataEntryMode,
  ProcedureType,
  StudyType,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import {TypedStudyAdapter} from 'studies/typed/utils/TypedStudyTypes';

import MultiProcedureRunAndPlanOverviewTabContents from '../shared/procedure-runs/overview/MultiProcedureRunAndPlanOverviewTabContents';
import ProcedureRunAndPlanOverview from '../shared/procedure-runs/overview/ProcedureRunAndPlanOverview';

export const AssayDevelopmentStudyAdapter: TypedStudyAdapter = {
  type: StudyType.ASSAY_DEVELOPMENT,

  procedureType: ProcedureType.ASSAY,

  isMultiProcedureRunEnabled: true,

  isMultiBatchEnabled: false,

  isMultiConditionEnabled: true,

  isNotificationSchedulesEnabled: false,

  isUnitOperationInstanceLinkingEnabled: true,

  isVisualizationEnabled: true,

  isOOTBChartingEnabled: false,

  maxRunsPerStudy: () => BenchlingConfig.STUDIES_MAX_NUM_EXPERIMENTS_PER_ASSAY_DEV_STUDY,

  defaultProcedureRunDataEntryMode: ProcedureRunDataEntryMode.INDIVIDUAL_CONDITION_REPLICATES,

  allowReturnToDesignPhase: false,

  allowRequireDesignApproval: false,

  creation: {},
  design: {
    ui: {
      tab: null,
    },
  },
  overview: {
    ui: {
      tab: MultiProcedureRunAndPlanOverviewTabContents,
      design: null,
      execution: ProcedureRunAndPlanOverview,
    },
  },
  review: {},
};
